import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatDatetimePipe } from './chat-datetime.pipe';

@NgModule({
	declarations: [ChatDatetimePipe],
	imports: [CommonModule],
	exports: [ChatDatetimePipe],
})
export class ChatDatetimeModule {}
